import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GLOBAL } from '../_config/config';
import { Observable } from 'rxjs';
import { Sampling, SamplingForm, SamplingResponse } from '../interfaces/sampling-record.interfaces';

/**
 * Servicio que gestiona los registros de muestreo asociados a las operaciones
 * de los barcos, permitiendo consultarlos, crearlos, actualizarlos y eliminarlos.
 */
@Injectable({
  providedIn: 'root'
})
export class SamplingRecordService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Obtiene los registros de muestreo de una operación.
   * @param operationId - Identificador de la operación.
   * @returns Observable con la lista de registros de muestreo.
   */
  getSamplingRecords(operationId: number): Observable<Sampling[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.barco.samplingRecord.list}${operationId}`;
    return this.http.get<Sampling[]>(url);
  }

  /**
   * Obtiene un registro de muestreo específico de una operación.
   * @param operationId - Identificador de la operación.
   * @param id - Identificador del registro de muestreo.
   * @returns Observable con el registro de muestreo.
   */
  getSamplingRecord(operationId: number, id: number): Observable<Sampling[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.barco.samplingRecord.get}${operationId}${id}`;
    return this.http.get<Sampling[]>(url);
  }

  /**
   * Crea un registro de muestreo.
   * @param sampling - Datos del registro de muestreo a crear.
   * @returns Observable con la respuesta de la creación.
   */
  createSamplingRecord(sampling: SamplingForm): Observable<SamplingResponse> {
    const url: string = `${GLOBAL.url}${GLOBAL.barco.samplingRecord.create}`;
    return this.http.post<SamplingResponse>(url, sampling);
  }

  /**
   * Actualiza un registro de muestreo.
   * @param sampling - Datos del registro de muestreo a actualizar.
   * @returns Observable con la respuesta de la actualización.
   */
  updateSamplingRecord(sampling: SamplingForm): Observable<SamplingResponse> {
    const url: string = `${GLOBAL.url}${GLOBAL.barco.samplingRecord.update}`;
    return this.http.put<SamplingResponse>(url, sampling);
  }

  /**
   * Elimina un registro de muestreo.
   * @param id - Identificador del registro a eliminar.
   * @returns Observable con la respuesta de la eliminación.
   */
  deleteSamplingRecord(id: number): Observable<[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.barco.samplingRecord.delete}`;
    return this.http.delete<[]>(url, {
      headers: new HttpHeaders(),
      body: {
        id
      }
    });
  }
}
